<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12" md="8">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                    outlined
                                                    label="Name"
                                                    v-model="$v.editedItem.name.$model"
                                                    :error-messages="nameError"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <autocomplete :items="documentRules"
                                                          :label="`Select ${docType.toLowerCase()} rules`"
                                                          title="name"
                                                          :sub-title="['subtitle']"
                                                          :selected-items="documentRulesSelected"
                                                          @autocomplete-selected="updateSelectedItems($event)"
                                            ></autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-divider class="d-none d-md-flex mx-4 my-4" vertical inset v-if="isDocument"></v-divider>
                                <v-col cols="12" md="3" v-if="isDocument">
                                    <v-row >
                                        <v-col cols="12" class="text-left">
                                            Apply to user category:
                                        </v-col>
                                        <v-col cols="6" md="12">
                                            <v-switch label="Employee"
                                                      :error-messages="userTypeError"
                                                      v-model="$v.employeeType.$model">
                                            </v-switch>
                                        </v-col>
                                        <v-col cols="6" md="12">
                                            <v-switch label="Client"
                                                      :error-messages="userTypeError"
                                                      v-model="$v.clientType.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">Cancel</v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="alertClosed($event)">
        </dialog-alert>
        <dialog-alert :text="notFoundError"
                      :alert-type="alertTypes.ERROR"
                      :open="openNotFound"
                      @alert-closed="close()">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import { required, minLength} from 'vuelidate/lib/validators';
    import {DocumentGroup} from '@/shared/dtos/Dtos';
    import {USER_TYPE} from '@/shared/enums/UserType';
    import {DOCUMENT_GROUP_ACTIONS} from '@/shared/enums/DocumentGroup';
    import {DOCUMENT_GROUP_TYPES} from "@/shared/enums/DocumentGroup";
    import {DOCUMENT_RULE_CONFIGURATIONS} from '@/shared/enums/DocumentRule';
    const Autocomplete = ()=> import( "@/components/common/Autocomplete");
    import { FORM_STATUS } from '@/shared/enums/FormStatuses';
    const DialogAlert = ()=> import( '@/components/common/DialogAlert');
    import {formUnsavedMixin} from "@/shared/mixins/FormUnsaved";
    import { ALPHA_NUMERIC_WITH_SPACES_VALIDATOR } from "@/shared/validators/Validators";
    import {WRONG_ID_SUPPLIED}  from "@/shared/enums/AlertTexts";
    import {ALERT_TYPES} from "@/shared/enums/AlertTexts";
    import {FREQUENCIES} from "@/shared/enums/Report";

    export default {
        name: "documentGroupForm",
        props:['id','action','docType'],
        components: {Autocomplete, DialogAlert},
        mixins:[formUnsavedMixin],
        data(){
            return {
                editedItem: {...DocumentGroup},
                employeeType: false,
                clientType: false,
                documentRules: [],
                documentRulesSelected:[],
                isSaving: false,
                notFoundError: WRONG_ID_SUPPLIED,
                openNotFound: false,
                alertTypes: ALERT_TYPES
            };
        },
        validations() {
            if(this.isDocument)
            {
                return {
                    editedItem:{
                        name: {
                            required,
                            minLength: minLength(2),
                            ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
                        }
                    },
                    employeeType:{
                        required: function()
                        {
                            return this.clientType || this.employeeType
                        }
                    },
                    clientType:{
                        required: function()
                        {
                            return this.clientType || this.employeeType
                        }
                    }
                }
            }

            return {
                editedItem:{
                    name: {
                        required,
                        minLength: minLength(2),
                        ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
                    }
                },
            }
        },
        computed:{
            isDocument(){
                return this.docType === DOCUMENT_GROUP_TYPES.DOCUMENT
            },
            nameError(){
                const errors = []
                if (!this.$v.editedItem.name.$dirty) {
                    return errors
                }

                !this.$v.editedItem.name.minLength && errors.push('Name must be at least '+
                    this.$v.editedItem.name.$params.minLength.min +' characters long')
                !this.$v.editedItem.name.required && errors.push('Name is required.')
                !this.$v.editedItem.name.ALPHA_NUMERIC_WITH_SPACES_VALIDATOR && errors.push('Name must contain only letters and numbers.')

                return errors
            },
            userTypeError(){
                const errors = []
                if(!this.isDocument || (!this.$v.employeeType.$dirty && !this.$v.clientType.$dirty)){
                    return errors
                }

                !this.$v.employeeType.required && errors.push('employee, client or both need to be selected')
                !this.$v.clientType.required && errors.push('employee, client or both need to be selected')
                return errors
            }
        },
        methods:{
            async initialize(){
                this.getDocumentRules();

                this.editedItem = {...DocumentGroup};
                this.editedItem.type = this.docType;

                if(this.id !== undefined)
                {
                    await this.$store.dispatch('getDocumentGroup',{id: this.id});

                    this.editedItem = this.$store.getters.getDocumentGroup;

                    if(!this.editedItem.hasOwnProperty('id'))
                    {
                        this.openNotFound = true;
                        return;
                    }

                    /**
                     * If clone then remove name and id from object
                     */
                    if(this.action === DOCUMENT_GROUP_ACTIONS.CLONE.text)
                    {
                        delete this.editedItem.id;
                        this.editedItem.name = '';
                    }

                    switch(this.editedItem.applyTo)
                    {
                        case USER_TYPE.CLIENT:
                            this.clientType = true;
                            break;
                        case USER_TYPE.EMPLOYEE:
                            this.employeeType = true;
                            break;
                    }
                }

                if(this.editedItem.hasOwnProperty('documentRules'))
                {
                    this.editedItem.documentRules = Object.values(this.editedItem.documentRules);
                    this.documentRulesSelected = this.editedItem.documentRules;
                }
            },
            updateSelectedItems($event){
                this.$v.editedItem.$touch();
                this.editedItem.documentRules = $event;
                this.documentRulesSelected = $event;
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;
                this.$router.push({name: this.isDocument ? 'documentGroupTable' : 'reportGroupTable'});
            },
            resetValues(){
                this.$v.$reset();
                this.editedItem = {...DocumentGroup};
                this.$store.commit('setDocumentGroup',null);
                this.employeeType = false;
                this.clientType = false;
            },
            async getDocumentRules(){
                //going backend
                try{
                    await this.$store.dispatch('getDocumentRules',{type: this.docType});
                    this.documentRules = this.$store.getters.getDocumentRules;
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.documentRules = this.documentRules.map((item) => {
                    if(this.isDocument)
                        return this.setSubtitleDocument(item);

                    return this.setSubtitleReport(item);
                });
            },
            setSubtitleReport(document){
                document.subtitle = FREQUENCIES.getFrequencyReadable(document.notificationInterval);
                return document;
            },
            setSubtitleDocument(document){
                let subTitleRequired = document.required ? DOCUMENT_RULE_CONFIGURATIONS.REQUIRED.REQUIRED : DOCUMENT_RULE_CONFIGURATIONS.REQUIRED.NO_REQUIRED;
                let subTitleExpiration = '';

                if(document.expiredInterval !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE)
                {
                    let interval = document.expiredInterval.split('-');
                    subTitleExpiration = `Expires in ${interval[0]} ${interval[1]}`;
                }
                else
                {
                    subTitleExpiration = DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.NO_EXPIRE_TEXT;
                }

                document.subtitle = subTitleRequired+' | '+subTitleExpiration;

                return document;
            },
            removeDocumentRule(documentRule){
                const index = this.editedItem.documentRules.indexOf(documentRule);
                this.editedItem.documentRules.splice(index, 1);
            },
            async save(){

                this.$v.$touch();

                if(this.$v.$anyError){
                    return;
                }

                this.isSaving = true;

                try{
                    /**
                     * Parsing template type
                     */
                    let applyTo = [];
                    if(this.employeeType) applyTo.push(USER_TYPE.EMPLOYEE);
                    if(this.clientType || !this.isDocument) applyTo.push(USER_TYPE.CLIENT);
                    this.editedItem.applyTo = applyTo.join('_');

                    /**
                     * Saving document group
                     */
                    await this.$store.dispatch('setDocumentGroup',this.editedItem);
                    let response = this.$store.getters.getDocumentGroup;

                    /**
                     * Updating list of document groups
                     */
                    this.$store.commit('setDocumentGroups', {type: this.docType, value: []});
                    if(this.employeeType) this.$store.commit('setDocumentGroups', {type: this.docType, value: [], applyTo: USER_TYPE.EMPLOYEE});
                    if(this.clientType) this.$store.commit('setDocumentGroups', {type: this.docType, value: [], applyTo: USER_TYPE.CLIENT});
                }catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.close();
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>